export const CATEGORIES = ['Yemek', 'Çorba', 'Tatlı', 'Zeytinyağlı', 'Poğaça', 'Börek', 'Kek', 'Kurabiye', 'Salata'];

export const DIFFICULTIES = ['Kolay', 'Orta', 'Zor'];

export const MAX_SCREENSHOTS = 5;

export const LOCK_CODE = '8585';
